import ZiniPixelsUXWizard from "./ZiniPixelsUXWizard";

export default ZiniPixelsUXWizard;
